<div class="toast" [class.show]="text">
  <div class="content">{{ text }}</div>
</div>
